import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Table, Tag } from 'antd';
import { TeamOutlined, CalendarOutlined, CrownOutlined, DollarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../utils/api';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => { loadStats(); }, []);

  async function loadStats() {
    try {
      const data = await request.get('/dashboard/stats');
      setStats(data.data);
    } catch (e) {} finally { setLoading(false); }
  }

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}>加载中...</div>;

  const upcomingCols = [
    { title: '活动名称', dataIndex: 'title', key: 'title' },
    { title: '日期', dataIndex: 'activityDate', key: 'date', render: d => new Date(d).toLocaleDateString('zh-CN') },
    { title: '类型', dataIndex: 'type', key: 'type', render: t => {
      const map = { family: '亲子', social: '白领', corp: '团建' };
      const colors = { family: 'green', social: 'orange', corp: 'blue' };
      return <Tag color={colors[t]}>{map[t]}</Tag>;
    }},
  ];

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>仪表盘</h2>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card><Statistic title="本月营收" value={stats?.monthlyRevenue || 0} prefix="¥" precision={2} /></Card>
        </Col>
        <Col span={6}>
          <Card><Statistic title="本月活动" value={stats?.monthlyActivities || 0} prefix={<CalendarOutlined />} /></Card>
        </Col>
        <Col span={6}>
          <Card><Statistic title="本月报名" value={stats?.monthlyRegistrations || 0} prefix={<TeamOutlined />} /></Card>
        </Col>
        <Col span={6}>
          <Card><Statistic title="大酋长" value={stats?.chiefCount || 0} prefix={<CrownOutlined />} suffix={`/ ${stats?.totalUsers || 0}`} /></Card>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Card title="即将举行的活动" extra={<a onClick={() => navigate('/activities')}>查看全部</a>}>
            <Table dataSource={stats?.upcomingActivities || []} columns={upcomingCols} pagination={false} rowKey="id" size="small" />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="快捷操作">
            <Row gutter={[12, 12]}>
              {[
                { label: '发布活动', path: '/activities/create', color: '#2E7D32' },
                { label: '管理轮播图', path: '/banners', color: '#FF9800' },
                { label: '会员管理', path: '/members', color: '#2196F3' },
                { label: '系统设置', path: '/system', color: '#9C27B0' },
              ].map(item => (
                <Col span={12} key={item.path}>
                  <Card hoverable onClick={() => navigate(item.path)}
                    style={{ background: item.color, border: 'none', cursor: 'pointer' }}
                    bodyStyle={{ padding: '20px', textAlign: 'center' }}
                  >
                    <span style={{ color: '#fff', fontSize: 16, fontWeight: 'bold' }}>{item.label}</span>
                  </Card>
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
